import { Phone, MessageSquareText } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import ServiceAreaMap from "@/components/ServiceAreaMap";
import CtaSection from "@/components/CtaSection";
import { PHONE_DISPLAY, TEL_HREF, SMS_HREF } from "@/data/site";

export default function ServiceAreas() {
  return (
    <>
      <Seo
        title="Service Areas | Greensboro NC & Surrounding Communities"
        description="Authentically Yours provides residential and commercial property services throughout Greensboro, NC and surrounding communities. Ask us about your location."
        path="/service-areas"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Service Areas", path: "/service-areas" },
        ]}
      />
      <PageHero
        eyebrow="Service Areas"
        title="Serving Greensboro, NC & Surrounding Communities"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Service Areas", path: "/service-areas" },
        ]}
      />

      <section className="container-x py-20 sm:py-28 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="text-ink/75 leading-relaxed text-lg max-w-xl">
            Based in Greensboro, North Carolina, Authentically Yours Property
            Services provides residential and commercial property services
            throughout Greensboro <span className="text-ink font-medium">and the many
            surrounding cities and communities</span> across the Triad — including nearby
            towns throughout Guilford County and the areas around it.
          </p>

          <div className="mt-10 border border-gold/25 bg-blush-soft/40 p-8">
            <h2 className="text-3xl text-ink">Check Your Location</h2>
            <p className="mt-3 text-ink/70 leading-relaxed">
              Not sure if you're in our service area? Call or text us at{" "}
              <span className="text-ink font-medium">{PHONE_DISPLAY}</span> to ask
              whether we service your area.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <a href={TEL_HREF} className="btn-primary" data-testid="areas-call">
                <Phone size={16} strokeWidth={1.75} aria-hidden="true" /> Call {PHONE_DISPLAY}
              </a>
              <a href={SMS_HREF} className="btn-ghost" data-testid="areas-text">
                <MessageSquareText size={16} strokeWidth={1.75} aria-hidden="true" /> Text Us
              </a>
            </div>
          </div>
        </div>

        <Reveal delay={0.1}>
          <ServiceAreaMap className="max-w-lg mx-auto" />
        </Reveal>
      </section>

      <CtaSection />
    </>
  );
}
